import { defineMessages } from 'react-intl'

export default defineMessages({
  select: {
    id: 'components.VoiceCompact.select',
    defaultMessage: 'Select',
  },
  deselect: {
    id: 'components.VoiceCompact.deselect',
    defaultMessage: 'Deselect',
  },
  latestJob: {
    id: 'components.VoiceCompact.latestJob',
    defaultMessage: 'Used {time}',
  },
  available: {
    id: 'components.VoiceCompact.available',
    defaultMessage: 'Available',
  },
  shortAge: {
    id: 'components.VoiceCompact.age.short',
    defaultMessage: '{age} y/o',
  },
  demoCount: {
    id: 'components.VoiceCompact.demoCount',
    defaultMessage:
      '{count} {count, plural, one {demo} other {demos} } selected',
  },
})
